module.exports = __webpack_public_path__ + "static/media/add-service-02.e909437d.png";